import React, { useState, useEffect, useRef } from 'react';
import './css/Main.css'; // Ensure you have the appropriate CSS styles
import MysteryForm from './MysteryForm';
import { useNavigate } from 'react-router-dom';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const Main = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    sessionStorage.setItem('canAccessPage', 'true');
    // Redirect the top-level window
    if (window.top) {
      window.top.location.href = 'https://piradite.nekoweb.org/home.html';
    } else {
      // Fallback for cases where window.top is not available
      window.location.href = 'https://piradite.nekoweb.org/home.html';
    }
  };
  

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (content) {
      const abortController = new AbortController();
      abortControllerRef.current = abortController;

      const existingElement = document.getElementById(content.id);
      if (existingElement) {
        existingElement.remove();
      }

      const newElement = document.createElement('div');
      newElement.id = content.id;
      newElement.className = 'hidden html';
      newElement.innerHTML = content.html;
      document.body.appendChild(newElement);

      Fancybox.show([
        {
          src: `#${content.id}`,
          type: 'inline',
        },
      ], {
        backdropClick: false,
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ['close'],
          },
        },
        on: {
          close: () => {
            const element = document.getElementById(content.id);
            if (element) {
              // Clean up iframes and other embedded content
              const iframes = element.querySelectorAll('iframe');
              iframes.forEach((iframe) => {
                iframe.src = 'about:blank'; // Stop video playback
                iframe.remove();
              });

              // Clean up videos and audios
              const mediaElements = element.querySelectorAll('video, audio');
              mediaElements.forEach((media) => {
                media.pause();
                media.currentTime = 0;
                media.remove();
              });

              // Clean up images and other embedded content
              const images = element.querySelectorAll('img');
              images.forEach((img) => {
                img.src = ''; // Optionally clear image sources
              });

              const embeds = element.querySelectorAll('embed');
              embeds.forEach((embed) => {
                embed.remove();
              });

              const objects = element.querySelectorAll('object');
              objects.forEach((object) => {
                object.remove();
              });

              const scripts = element.querySelectorAll('script');
              scripts.forEach((script) => {
                script.remove();
              });

              element.remove();
              setContent(null);

              if (abortControllerRef.current) {
                abortControllerRef.current.abort();
              }
            }
          },
        },
      });
    }
  }, [content]);

  const handleChange = (e) => {
    setCode(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (code.trim().length < 2) {
      setError('Code is too short');
      setIsLoading(false);
      return;
    }

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const response = await fetch('https://piradite-server.vercel.app/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        },
        body: JSON.stringify({ code: code.trim() }),
        signal: abortController.signal,
      });

      if (response.status === 404) {
        setError('Invalid code');
        setContent(null);
      } else if (!response.ok) {
        setError('Error fetching content');
        setContent(null);
      } else {
        const newContent = await response.text();
        const existingElement = document.getElementById(code.trim());
        if (existingElement) {
          existingElement.remove();
        }
        setContent({
          id: code.trim(),
          html: newContent,
        });
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Request aborted');
      } else {
        setError('Error submitting code');
        setContent(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="default bg-black">
      <div className="dot-overlay"></div> {/* Dot overlay */}
      <main>
        <div className="font" style={{ backgroundColor: 'black', textAlign: 'center' }}>
          <div className="gif-container">
            <img 
              onClick={handleNavigate}
              className="gif"
              src="https://i.pinimg.com/originals/f0/5e/7f/f05e7f3e62e73baceb90cda63c36c607.gif" 
              alt="GIF"
            />
            <input 
              className="hover-message"
              value="No one can hear you scream, 'Cause no one cares at all."
              readOnly
            />
          </div>
          <br /><br /><br /><br /><br />
        </div>
        <div>
          <MysteryForm
            code={code}
            onChange={handleChange}
            onSubmit={handleSubmit}
            error={error}
            isLoading={isLoading}
          />
        </div>
      </main>
    </div>
  );
};

export default Main;
